export default __webpack_public_path__ + "static/media/creative-tim-white-slim2.c9b2f68e.png";